/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { intl } from "../../services/intlGlobalProvider";
import { ListView } from "antd-mobile";
import SearchItem from "../SearchItem";
import "./index.css";

class SearchListing extends Component {
  onItemClicked = (foodId, searchQuery) => {
    const { onItemClicked } = this.props;

    onItemClicked && onItemClicked(foodId, searchQuery);
  };

  render() {
    const { items } = this.props;
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });

    return (
      <ListView
        className={"search-listing"}
        ref={el => (this.lv = el)}
        dataSource={dataSource.cloneWithRows(items)}
        renderHeader={() => {
          return (
            <div
              style={{
                padding: "10px 0",
                width: "100%",
                textAlign: "start",
                color: "gray",
                fontSize: "0.9em"
              }}
            >
              {intl.formatMessage(
                {
                  id: "search.result.text"
                },
                { qty: items.length }
              )}
            </div>
          );
        }}
        renderFooter={() => {
          return (
            <div
              style={{
                width: "100%",
                color: "gray",
                fontSize: "0.9em"
              }}
            >
              {intl.formatMessage({ id: "app.loaded" })}
            </div>
          );
        }}
        renderRow={data => {
          return <SearchItem item={data} onItemClicked={this.onItemClicked} />;
        }}
        pageSize={10}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={800}
        style={{
          height: "100%",
          width: "100%"
        }}
      />
    );
  }
}

SearchListing.propTypes = {
  items: PropTypes.array.isRequired,
  onItemClicked: PropTypes.func
};

SearchListing.defaultProps = {};

export default SearchListing;



// WEBPACK FOOTER //
// ./src/components/SearchListing/index.js